module.exports = __webpack_public_path__ + "static/media/Coc.25fead56.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/Terms_Conditions/Coc.pdf
// module id = 2476
// module chunks = 0